import { render, staticRenderFns } from "./StudentLearningProgressLayout.vue?vue&type=template&id=7b65c368&scoped=true&lang=pug&"
import script from "./StudentLearningProgressLayout.vue?vue&type=script&lang=ts&"
export * from "./StudentLearningProgressLayout.vue?vue&type=script&lang=ts&"
import style0 from "./StudentLearningProgressLayout.vue?vue&type=style&index=0&id=7b65c368&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b65c368",
  null
  
)

export default component.exports